import { Grid, Container } from '@mui/material';
import ProductCard from './ProductCard';
import { products } from '../config/products';

const ProductGrid = () => (
  <Container maxWidth={false} sx={{ py: 5, flex: 1, maxWidth: 1400 }}>
    <Grid container spacing={3}>
      {products.map((product) => (
        <Grid size={{ xs: 12, sm: 6, md: 3 }} key={product.id}>
          <ProductCard product={product} />
        </Grid>
      ))}
    </Grid>
  </Container>
);

export default ProductGrid;
